/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppleLoginRequest } from '../models/AppleLoginRequest';
import type { PasswordAccountCreateRequest } from '../models/PasswordAccountCreateRequest';
import type { PasswordChangeRequest } from '../models/PasswordChangeRequest';
import type { PasswordLoginRequest } from '../models/PasswordLoginRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * @param teamCode
     * @param appRedirectUrl
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAuthLineLogin(
        teamCode?: string,
        appRedirectUrl?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Auth/line/login',
            query: {
                'teamCode': teamCode,
                'appRedirectUrl': appRedirectUrl,
            },
        });
    }
    /**
     * @param teamCode
     * @param code
     * @param state
     * @param error
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAuthLineCallback(
        teamCode: string,
        code?: string,
        state?: string,
        error?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Auth/line/{teamCode}/callback',
            path: {
                'teamCode': teamCode,
            },
            query: {
                'code': code,
                'state': state,
                'error': error,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAuthAppleLogin(
        requestBody?: AppleLoginRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/apple/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAuthAccount(
        requestBody?: PasswordAccountCreateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/account',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAuthPasswordLogin(
        requestBody?: PasswordLoginRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/password/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAuthAccountChangePassword(
        requestBody?: PasswordChangeRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Auth/account/change-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAuthMe(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Auth/me',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAuthMe(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Auth/me',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param idToken
     * @param teamCode
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAuthBindLineAccount(
        idToken?: string,
        teamCode?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Auth/BindLineAccount',
            query: {
                'idToken': idToken,
                'teamCode': teamCode,
            },
        });
    }
}
